import React from "react"
import {Box} from "@chakra-ui/react"

import {CatIcon} from "./app"
import {colorPalette, icons} from "@utils/icons"


export const iconList = Object.keys(icons).map(iconKey => ({
    label: iconKey,
    value: icons[iconKey],
    element: <div className="flex space-x-4 items-center">
        <CatIcon icon={icons[iconKey]} iconSize="lg"/>
        <span>{iconKey}</span>
    </div>
}))

export const colorList = Object.keys(colorPalette).map(colorKey => ({
    label: colorKey,
    value: colorPalette[colorKey],
    element: <Box bg={colorPalette[colorKey]} w="100%" p={2}></Box>
}))